import script from "./AdminHealth.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHealth.vue?vue&type=script&setup=true&lang=js"

import "./AdminHealth.vue?vue&type=style&index=0&id=c129bcec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c129bcec"]])

export default __exports__